// src/components/Hero.js
import React from "react";

import "./Hero.css";
import signupMockup from "../assets/images/signupmockup.png";
import { Link } from "react-router-dom";
function Hero() {
  return (
    <section className="hero" id="home">
      <img
        src={signupMockup}
        alt="Quiz App Signup Mockup"
        className="hero-mockup"
      />
      <div className="container hero-content">
        <h1 className="hero-title">
          Test Your Knowledge.
          <span className="highlight-text"> Challenge Your Mind.</span>
        </h1>
        <p className="hero-subtitle">
          Dive into the ultimate quiz experience with daily challenges,
          power-ups, and leaderboard competition. Download now and start popping
          quizzes!
        </p>
        <div className="hero-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=com.rovenkodev.quizzypop"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get on Google Play
          </a>
          <Link to="/features" className="btn btn-secondary">
            Learn More
          </Link>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <div className="stat-number">15+</div>
            <div className="stat-label">Quiz Categories</div>
          </div>
          <div className="stat">
            <div className="stat-number">1500+</div>
            <div className="stat-label">Questions</div>
          </div>
          <div className="stat">
            <div className="stat-number">⚡</div>
            <div className="stat-label">Power-Ups</div>
          </div>
          <div className="stat">
            <div className="stat-number">🏆</div>
            <div className="stat-label">Competitions</div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Hero;
